/* eslint-env jquery */

"use strict";

function getUrlObject() {
    // Get the URL from window.location.href or any other URL string
    const url = new URL(window.location.href);
    // Get the search parameters from the URL
    const searchParams = new URLSearchParams(url.search);

    return {
        url: url,
        searchParams: searchParams,
    };
}

function updateFormType() {
    const urlObject = getUrlObject();
    const type = urlObject.searchParams.get("type");

    if (!type) {
        $(".voucher-physical").addClass("d-none");
        $(".voucher-digital").removeClass("d-none");
        $("#radio-digital").prop("checked", true);
        $(".voucher-digital").find("input").attr("disabled", false);
        $(".voucher-digital").find("textarea").attr("disabled", false);
        $(".voucher-physical").find("input").attr("disabled", true);
        $(".voucher-physical").find(".product-quantity").val(1);
        $(".card-type-physical").removeClass("selected");
        $(".card-type-egift").addClass("selected");
    } else {
        $(".voucher-physical").removeClass("d-none");
        $(".voucher-digital").addClass("d-none");
        $("#radio-physical").prop("checked", true);
        $(".voucher-digital").find("input").attr("disabled", true);
        $(".voucher-digital").find("textarea").attr("disabled", true);
        $(".voucher-physical").find("input").attr("disabled", false);
        $(".card-type-egift").removeClass("selected");
        $(".card-type-physical").addClass("selected");
    }
}

function setTypeQueryParameter(type) {
    const urlObject = getUrlObject();

    if (type === "physical") {
        urlObject.searchParams.append("type", "physical");
    } else {
        urlObject.searchParams.delete("type");
    }

    // Set the search params
    urlObject.url.search = urlObject.searchParams.toString();
    // Set the URL
    window.history.pushState(null, null, urlObject.url.toString());
}

var wr = function (type) {
    var orig = window.history[type];
    return function () {
        var rv = orig.apply(this, arguments);
        var e = new Event(type);
        e.arguments = arguments;
        window.dispatchEvent(e);
        return rv;
    };
};

window.history.pushState = wr("pushState");

module.exports = {
    giftCard: function () {
        updateFormType();

        $(".redeem-button").addClass("d-none");

        if ($(".check-balance-form").length) {
            const balanceFormUrl = $(".check-balance-form").attr("action");
            const balanceFormUrlArr = balanceFormUrl.split("?");
            if (balanceFormUrlArr.length && balanceFormUrlArr.length > 1) {
                $(".redeem-button").removeClass("d-none");
            }
        }

        var currentDate = new Date();
        var maxDate = new Date();
        maxDate.setDate(maxDate.getDate() + 30);

        if ($(".receipt-date").length) {
            $(".receipt-date").datepicker({
                dateFormat: "dd/mm/y",
                minDate: currentDate,
                maxDate: maxDate,
            });
        }

        $("body").on("change", ".gift-voucher", function () {
            $(this).val();
            setTypeQueryParameter($(this).val());
            updateFormType();
        });

        $("body").on("click", ".giftcard-values li.fixed-giftCard-value", function () {
            $(".giftcard-values").find("li.fixed-giftCard-value").removeClass("selected");
            $(".gift-card-amount-value").attr("required", false);
            var value = $(this).find(".js-giftcardoption").data("value");
            $(".gift-card-amount-value").val(value);
            $(this).addClass("selected");
        });

        $("body").on("focus", "li.custom-giftCard-value input", function () {
            $(".giftcard-values").find("li").removeClass("selected");
            $(".gift-card-amount-value").attr("required", true);
        });

        $("body").on("keyup", ".receipt-message", function () {
            const maxLength = parseInt($(this).attr("maxlength"), 10);
            const messageLength = $(this).val().length;
            $(".gift-card-message-remaining").find("span").text(maxLength - messageLength);
        });

        $("body").on("submit", ".giftcard-form", function (e) {
            e.preventDefault();

            const urlObject = getUrlObject();
            const type = urlObject.searchParams.get("type");
            const $form = $(this);
            $form.spinner().start();

            let cardAmount = 0;

            if ($(".giftcard-values li.fixed-giftCard-value.selected").length) {
                cardAmount = Number($(".giftcard-values li.fixed-giftCard-value.selected").find(".js-giftcardoption").data("value"));
            } else {
                const $cardAmount = $(".gift-card-amount-value");
                const cardAmountMinRange = Number($cardAmount.data("min-range"));
                const cardAmountMaxRange = Number($cardAmount.data("max-range"));
                cardAmount = Number($cardAmount.val());

                if (cardAmount > cardAmountMaxRange || cardAmount < cardAmountMinRange) {
                    $cardAmount.addClass("is-invalid");
                    $(".custom-giftCard-value").find(".invalid-feedback").text($cardAmount.data("range-error"));
                    $form.spinner().stop();
                    return false;
                } else {
                    $cardAmount.removeClass("is-invalid");
                    $(".custom-giftCard-value").find(".invalid-feedback").text("");
                }
            }
            const form = {
                quantity: $form.find(".product-quantity").val(),
                cardType: type ? type : "digital",
                cardAmount: cardAmount
            };

            if (!type) {
                if (!$(".receipt-message").val()) {
                    $(".receipt-message").attr("required", true);
                    $(".receipt-message").next().text($(".receipt-message").data("missing-error"));
                    $(".receipt-message").addClass("is-invalid");
                    $form.spinner().stop();
                    return false;
                } else {
                    $(".receipt-message").attr("required", false);
                    $(".receipt-message").next().text("");
                    $(".receipt-message").removeClass("is-invalid");
                }

                form.pid = $(".voucher-digital").find("input.product-id").val();

                form.recipientName = $("input[name$=_receiptName]").val();
                form.recipientEmail = $("input[name$=_receiptEmail]").val();
                form.recipientNameFrom = $("input[name$=_receiptNameFrom]").val();
                form.recipientDate = $("input[name$=_receiptDate]").val();
                form.message = $(".receipt-message").val();
            } else {
                form.pid = $(".voucher-physical").find("input.product-id").val();
            }

            $.ajax({
                url: $form.attr("action"),
                method: "POST",
                data: form,
                success: function (data) {
                    $.spinner().stop();
                    window.location.href = data.redirectUrl;
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });

        $("body").on("submit", ".check-balance-form", function (e) {
            e.preventDefault();
            let clickedButtonName = $(this).find(":submit:focus").attr("name");
            if (clickedButtonName == undefined) {
                let originalSubmitter = e.originalEvent.submitter;
                if (originalSubmitter) {
                    clickedButtonName = e.originalEvent.submitter.name;
                }
            }
            const $form = $(this);
            $form.spinner().start();
            let url = $form.attr("action");

            if (clickedButtonName === "redeem") {
                url = $form.data("redeem-url");
            }

            $.ajax({
                url: url,
                type: "post",
                dataType: "json",
                data: $form.serialize(),
                success: function (data) {
                    $form.spinner().stop();
                    if (data.checkedBalanceMessage) {
                        $(".gift-card-balance-message").text(data.checkedBalanceMessage).removeClass("d-none");
                    } else {
                        $(".gift-card-balance-message").text("").addClass("d-none");
                    }

                    if (data.error) {
                        $(".gift-card-balance-message").addClass("error-unassigned-category");
                    } else {
                        $(".gift-card-balance-message").removeClass("error-unassigned-category");
                    }

                    if (clickedButtonName === "redeem") {
                        const $freeOfChargeTab = $(".nav-item[data-method-id=FREE_OF_CHARGE]");
                        if ((data.remainingBalance || data.remainingBalance === 0) && data.remainingBalance >= 0) {
                            $(".nav-item").addClass("d-none");
                            if ($freeOfChargeTab.hasClass("d-none")) {
                                $freeOfChargeTab.removeClass("d-none");
                                let freeOfChargeTabText = $(".freeofcharge-tab").text();
                                let freeOfChargeContentText = $(".freeofcharge-content .display-name").text();
                                if (freeOfChargeTabText.includes("Free of Charge")) {
                                    freeOfChargeTabText = freeOfChargeTabText.replace("Free of Charge", "Gift Card");
                                    freeOfChargeContentText = freeOfChargeContentText.replace("Free of Charge", "Gift Card");

                                } else if (freeOfChargeTabText.includes("BeautyVIP Voucher") && !freeOfChargeTabText.includes("Gift Card")) {
                                    freeOfChargeTabText = freeOfChargeTabText.replace("BeautyVIP Voucher", "Gift Card + BeautyVIP Voucher");
                                    freeOfChargeContentText = freeOfChargeContentText.replace("BeautyVIP Voucher", "Gift Card + BeautyVIP Voucher");
                                }
                                $(".freeofcharge-tab").text(freeOfChargeTabText);
                                $(".freeofcharge-content .display-name").text(freeOfChargeContentText);
                            }
                            $freeOfChargeTab.trigger("click");
                            $(".tab-pane").removeClass("active");
                            $(".tab-pane.freeofcharge-content").addClass("active");
                        } else {
                            if ($freeOfChargeTab.find("a").hasClass("active")) {
                                $freeOfChargeTab.find("a").removeClass("active");
                            }
                        }

                        if (data.balanceMessage) {
                            const $giftCardContainer = $("<div data-id=\"" + $("#giftCardNumber").val() + "\"></div>");
                            $giftCardContainer.append(data.balanceMessage + "<br/>");

                            // Hide AfterPay tab after applying gift card
                            if (!$(".nav-item.afterpay-tab").hasClass("d-none")) {
                                $(".nav-item.afterpay-tab").addClass("d-none");
                            }

                            if (data.appliedCardMessage && $giftCardContainer) {
                                $giftCardContainer.append(data.appliedCardMessage + "<br/>");
                            }

                            if (data.remainingBalanceMessage && $giftCardContainer) {
                                $giftCardContainer.append(data.remainingBalanceMessage);
                            }

                            if (data.insufficientBalanceMessage && $giftCardContainer) {
                                $giftCardContainer.append("<br/>" + data.insufficientBalanceMessage);
                            }

                            $(".applied-giftcard").append($giftCardContainer);
                        }
                    }
                },
                error: function () {
                    $form.spinner().stop();
                    window.location.reload();
                }
            });
        });

        $("body").on("click", ".remove-giftcard", function (e) {
            e.preventDefault();
            const $giftCardContainer = $(this).closest("div");
            const cardNumber = $giftCardContainer.data("id");
            const $form = $(".check-balance-form");
            $form.spinner().start();
            $.ajax({
                url: $form.data("remove-url") + "?cardNumber=" + cardNumber,
                type: "post",
                dataType: "json",
                success: function (data) {
                    $giftCardContainer.remove();
                    if ((data.remainingTotalPrice || data.remainingTotalPrice === 0) && data.remainingTotalPrice <= 0) {
                        $(".nav-item").addClass("d-none");

                        if ($(".nav-item[data-method-id=FREE_OF_CHARGE]").hasClass("d-none")) {
                            $(".nav-item[data-method-id=FREE_OF_CHARGE]").removeClass("d-none");
                        }
                        $(".nav-item[data-method-id=FREE_OF_CHARGE]").trigger("click");
                        $(".tab-pane").removeClass("active");
                        $(".tab-pane.freeofcharge-content").addClass("active");
                    } else {
                        $(".nav-item").removeClass("d-none");

                        if (!$(".nav-item[data-method-id=FREE_OF_CHARGE]").hasClass("d-none")) {
                            $(".nav-item[data-method-id=FREE_OF_CHARGE]").addClass("d-none");
                        }
                        $(".nav-item[data-method-id=FREE_OF_CHARGE]").find("a").removeClass("active");
                        $(".tab-pane").removeClass("active");
                        $(".tab-pane.windcave-mhpp-content").addClass("active");
                        $(".nav-link.windcave-mhpp-tab").trigger("click");
                    }

                    if (data.hasGiftCard) {
                        // Hide AfterPay tab after removing gift card
                        if (!$(".nav-item.afterpay-tab").hasClass("d-none")) {
                            $(".nav-item.afterpay-tab").addClass("d-none");
                        }
                    }
                    $form.spinner().stop();
                },
                error: function () {
                    $form.spinner().stop();
                    window.location.reload();
                }
            });
        });

        $("body").on("checkout:updateCheckoutView", function (e, data) {
            window.order = data.order;
        });

        $(window).on("pushState", function () {
            if (window.location.search.indexOf("?stage=shipping") > -1 && window.order.hasOnlyDigitalGiftCard) {
                window.location.href = window.location.origin + window.location.pathname + "?stage=payment#payment";
            }
        });
    },
};
